import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import DataContext from './DataContext';
function EmojiProvider({ data, children }) {
    if (!data) {
        throw new Error('Please pass a data value to EmojiProvider');
    }
    return (_jsx(DataContext.Provider, Object.assign({ value: data }, { children: children })));
}
EmojiProvider.propTypes = {
    data: PropTypes.object.isRequired,
};
export default EmojiProvider;
//# sourceMappingURL=EmojiProvider.js.map